import {EmailTemplateContent} from "./EmailTemplateContent";

export class EmailTemplate {
    public id: number;
    public name: string;
    public description: string;
    public templateKey: string;
    public contents: EmailTemplateContent[] = [];
}